// import React from 'react';

// const Hero = () => {
//   return (
//     <section className="bg-gradient-to-r from-indigo-500 to-pink-500 text-white min-h-screen flex items-center justify-center">
//       <div className="text-center px-4 max-w-2xl">
        
//         <h1 className="text-4xl md:text-6xl font-bold mb-4">
//           Hi, I’m Priyanka Yadav
//         </h1>

//         <p className="text-lg md:text-2xl mb-3 font-medium">
//           Java Backend Developer | Building Scalable APIs
//         </p>

//         <p className="text-sm md:text-base mb-6 text-gray-200">
//           I help businesses & startups build fast, secure and scalable backend systems 🚀
//         </p>

//         <div className="flex flex-wrap justify-center gap-4">
          
//           {/* View Projects */}
//           <a
//             href="#projects"
//             className="bg-white text-indigo-600 font-semibold px-6 py-2 rounded hover:bg-gray-100 transition"
//           >
//             View Work
//           </a>

//           {/* Start Project */}
//           <a
//             href="#contact"
//             className="bg-black text-white font-semibold px-6 py-2 rounded hover:opacity-80 transition"
//           >
//             Start a Project
//           </a>

//           {/* Resume */}
//           <a
//             href="/resume.pdf"  // <-- yaha apna resume file daalna
//             target="_blank"
//             rel="noopener noreferrer"
//             className="border border-white px-6 py-2 rounded hover:bg-white hover:text-indigo-600 transition"
//           >
//             Download Resume
//           </a>

//         </div>
//       </div>
//     </section>
//   );
// };

// export default Hero;

import React from 'react';

const Hero = () => {
  return (
    <section id="home" className="bg-gradient-to-r from-gray-900 via-indigo-900 to-black text-white min-h-screen flex items-center justify-center">
      
      <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-2 gap-10 items-center">
        
        {/* LEFT CONTENT */}
        <div>
          <h1 className="text-4xl md:text-6xl font-bold mb-4 leading-tight">
            Hi, I’m <span className="text-indigo-400">Priyanka Yadav</span> 
          </h1>

          <p className="text-lg md:text-2xl mb-4 text-gray-300">
            Java Full Stack Developer
          </p>

          <p className="text-gray-400 mb-6">
            I build scalable backend systems and modern web applications using Spring Boot & React.
            Helping businesses turn ideas into powerful digital solutions.
          </p>

          {/* BUTTONS */}
          <div className="flex gap-4 flex-wrap">
            <a
              href="#contact"
              className="bg-indigo-600 px-6 py-3 rounded-lg font-semibold shadow hover:bg-indigo-700 hover:scale-105 transition"
            >
              Hire Me
            </a>

            <a
              href="https://github.com/priyankayadav33"
              target="_blank"
              rel="noopener noreferrer"
              className="border border-gray-400 px-6 py-3 rounded-lg hover:bg-white hover:text-black transition"
            >
              GitHub
            </a>
          </div>
        </div>

        {/* RIGHT SIDE IMAGE / CARD */}
        <div className="flex justify-center">
          <div className="bg-white/10 backdrop-blur-lg p-6 rounded-2xl shadow-xl border border-white/20">
            
           <img
  src="/profile.jpeg"
  alt="Priyanka Yadav"
  className="w-50 h-60 object-contain mx-auto rounded-full border-4 border-indigo-400 shadow-xl bg-white"
/>
            <p className="text-center mt-4 text-gray-300">
              Building Scalable & Modern Applications 
            </p>

          </div>
        </div>

      </div>
    </section>
  );
};

export default Hero;